import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { organizedNeeds, systemFlow } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
export function ProblemSolution() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-184" data-mp="3mrb7671y0tw9">
      <div className="mx-auto max-w-5xl" data-id="element-185" data-mp="3hr6qoh11bz61">
        <SectionTitle data-id="element-186" data-mp="3hs8dfireya3l">
          What if your sports massage sessions <Mark data-id="element-187" data-mp="ic1wdk693ucy">were already organized?</Mark>
        </SectionTitle>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-slate-600 md:text-base" data-id="element-188" data-mp="iba68ovfaou2">
          You may already know dozens of massage techniques. The challenge is knowing which protocols to select, how to
          combine them, how to organize the available time, and how to adapt each session to the athlete in front of
          you.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-center text-sm leading-relaxed text-slate-600 md:text-base" data-id="element-189" data-mp="120u8fgh08yt4">
          With <strong className="text-blue-950" data-id="element-190" data-mp="x814gutd1ui3">Complete Sports Massage Bundle</strong>, you get a structured
          professional resource library covering session planning, lower-body and upper-body protocols, event-based
          massage, and complete sport-specific sessions.
        </p>
        <p className="mt-5 text-center text-sm font-black uppercase tracking-[.2em] text-blue-700" data-id="element-191" data-mp="3u53cokqqj7sk">
          Plan. Select. Apply. Adapt.
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-192" data-mp="3k7ovgiwzmez7">
          <div className="flex flex-col rounded-2xl border border-blue-950/10 bg-slate-50 p-6" data-id="element-193" data-mp="3k643n1225a51">
            <h3 className="text-base font-black uppercase leading-tight text-blue-950 md:text-lg" data-id="element-194" data-mp="3p7teogpa5nt4">
              Turn scattered techniques into clear, professional sessions
            </h3>
            <div className="mt-3 flex-1 space-y-2 text-sm leading-relaxed text-slate-600" data-id="element-195" data-mp="3f8ufdoqen4is">
              <p data-id="element-196" data-mp="19gp2e9rawxs1">
                Techniques saved from videos, training courses, notes, and different resources can quickly become
                difficult to organize.
              </p>
              <p data-id="element-197" data-mp="2meyz9352d2bn">
                This system brings professional sports massage protocols together in one place, with practical
                sequences, client positioning, regional techniques, estimated durations, and adaptations.
              </p>
              <p data-id="element-198" data-mp="28e4qgje3szcg">
                Instead of searching through multiple resources before each appointment, access organized material
                designed around real professional situations.
              </p>
            </div>
            <p className="mt-5 text-xs font-black uppercase tracking-wider text-blue-700" data-id="element-199" data-mp="312k34z9rj5km">
              More structure. More confidence in preparation. Better organization.
            </p>
          </div>

          <div className="flex flex-col rounded-2xl bg-blue-950 p-6" data-id="element-200" data-mp="2rdsdixs6cxcv">
            <h3 className="text-base font-black uppercase leading-tight text-white md:text-lg" data-id="element-201" data-mp="3os4nnmlkeaw0">
              One system. Multiple sports. <span className="text-sky-300" data-id="element-202" data-mp="3k1egc3tkvxyo">Practical protocols ready to use.</span>
            </h3>
            <ul className="mt-4 flex-1 space-y-2.5" data-id="element-203" data-mp="3rdm36g9v8de8">
              {organizedNeeds.map(item => <li key={item.question} className="flex items-start gap-2 text-sm text-white/85" data-id="element-204" data-mp="7ks47pwhjsl">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sky-300" aria-hidden="true" data-id="element-205" data-mp="54jj4he9pamk" />
                  <span data-id="element-206" data-mp="9895d07gzg4f">
                    <strong className="font-bold text-white" data-id="element-207" data-mp="98r7uekq6qks">{item.question}</strong> {item.answer}
                  </span>
                </li>)}
            </ul>
            <ol className="mt-5 flex flex-wrap items-center gap-1.5" data-id="element-208" data-mp="j4c7w768hgrw">
              {systemFlow.map((step, index) => <li key={step} className="flex items-center gap-1.5" data-id="element-209" data-mp="nwm1pyagz0zg" data-mpi={index}>
                  {index > 0 && <ArrowRightIcon className="h-3.5 w-3.5 text-sky-300" aria-hidden="true" data-id="element-210" data-mp="stvrxg5ongoc" />}
                  <span className="whitespace-nowrap rounded-md bg-white px-2 py-1 text-[10px] font-black uppercase tracking-wide text-blue-950" data-id="element-211" data-mp="wxttdxihd3kk">
                    {step}
                  </span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}